import * as React from "react";
import { Route } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../misc/components/Authorization";
import { AlignPermissionsToRole } from "./AlignPermissionsToRole";
import { AlignRoles } from "./AlignRoles";
import { CreateRole } from "./CreateRole";
import { RoleManagementSummary } from "./RoleManagementSummary";

export const RolesRoot = () => {
    const { currentUserPermissions } = useSecurityContext();
    const { study } = useCurrentStudyConfigurationContext();

    return (
        <React.StrictMode>
            <Authorization currentPermissions={currentUserPermissions} studyId={study.id} permissionId={PermissionEnum.ViewRoleManagement}>
                <Route exact path="/RoleManagement" component={RoleManagementSummary} />
                <Route exact path="/RoleManagement/Create" component={CreateRole} />
                <Route path="/RoleManagement/Permissions/:id" component={AlignPermissionsToRole} />
                <Route path="/RoleManagement/Roles/:id" component={AlignRoles} />
            </Authorization>
        </React.StrictMode>
    );
}
